import React from 'react';
import loadable from '@loadable/component';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from '../../../../common/components';
// const ListJobsPositionPage = React.lazy(() => import('./ListJobsPositionPage'));
// const AddJobsPositionPage = React.lazy(() => import('./AddJobsPositionPage'));
// const EditJobsPositionPage = React.lazy(() => import('./EditJobsPositionPage'));
// const ViewJobsPositionPage = React.lazy(() => import('./ViewJobsPositionPage'));

// Routes
const ListJobsPositionPage = loadable(() => import('./ListJobsPositionPage'), {
  fallback: <Loader />
});
const AddJobsPositionPage = loadable(() => import('./AddJobsPositionPage'), {
  fallback: <Loader />
});
const EditJobsPositionPage = loadable(() => import('./EditJobsPositionPage'), {
  fallback: <Loader />
});
const ViewJobsPositionPage = loadable(() => import('./ViewJobsPositionPage'), {
  fallback: <Loader />
});

const JobsPositionRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListJobsPositionPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddJobsPositionPage t={t} alert={alert} />} />
      <Route exact path="/edit/:id" element={<EditJobsPositionPage t={t} alert={alert} />} />
      <Route exact path="/view/:id" element={<ViewJobsPositionPage t={t} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
JobsPositionRoute.propTypes = {
  t: PropTypes.func
};
export default JobsPositionRoute;
